export default __webpack_public_path__ + "static/media/pain_level_high_smile.70cc0c35.svg";